module.exports = __webpack_public_path__ + "static/media/tyre-two.d9b4005c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-two.png
// module id = 8
// module chunks = 0